// extracted by mini-css-extract-plugin
export default {"title":"RegexItem_title__ESX0U","regexList":"RegexItem_regexList__6ZZ2r","regexItem":"RegexItem_regexItem__dIHrp","regexCheckItem":"RegexItem_regexCheckItem__EadbF"};